// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		 });


		 let numberSlider = document.querySelectorAll("#slickNumber ul li");
		 if(numberSlider != undefined ){
			numberSlider.forEach((li, index) =>{
				if(index<10){
					li.firstChild.textContent = `0${li.firstChild.textContent}`;
					let button = li.childNodes[0];
					button.removeAttribute('aria-label');
					button.setAttribute("alt",`${li.firstChild.textContent}`)
				}
			})
		 }


		//Creation curve text 
		// let nuevoTexto = document.createElement("div");
		// nuevoTexto.className="container-intro-text";
		// let text = document.querySelectorAll('.middle-circle')[0].textContent;
		// let arrayText = text.split("");
		// arrayText.forEach((value, index) =>{
		// 	nuevoTexto.innerHTML += `<span class="letter-Circle" style="transform:rotate(${index * -9}deg)">
		// 								<span class="letter" style="transform:rotate(${index * 9}deg)"> ${value} </span> 
		// 							</span>`
		// })
		// let neuvoTexto2 = document.getElementById("neuvoTexto");
		// neuvoTexto2.appendChild(nuevoTexto);


		document.getElementById('burgerMenu').addEventListener('click', function () {
			if (!this.classList.contains('open')) {
				this.parentElement.classList.add('open');
				this.classList.add('open');
				document.querySelector(".overlay").classList.add("open");
				document.getElementById("social-mobile").classList.remove("hidden");
				document.getElementById("logo-sm").classList.remove("hidden");
				let button = document.getElementById("Close").parentElement.parentElement;
				if (button.childNodes.length == 2) {
					let newText = document.createElement("div");
					newText.textContent = "CLOSE";
					newText.classList.add("jsCloseBtn")
					button.appendChild(newText);
				}
			}
			else {
				this.classList.remove('open');
				document.getElementById("logo-sm").classList.add("hidden");
				let button = document.getElementById("Close").parentElement.parentElement;
				button.removeChild();
				this.parentElement.classList.remove('open');
				document.querySelector(".overlay").classList.remove("open");
			}
		});
		 //close btn mobile
		 let closeBtn = document.querySelectorAll(".nav-container")[0];
		 let newButton = closeBtn.childNodes[1];
		 if (newButton != undefined) {
			 if (closeBtn.childNodes[1].classList.contains("mobile")) {
				 let generalbutton = closeBtn.childNodes[1].children[0].children[0];
				 generalbutton.addEventListener('click', function () {
					document.getElementById("social-mobile").classList.add("hidden");
					 document.getElementById("logo-sm").classList.add("hidden");
					 document.querySelectorAll('.overlay')[0].classList.remove('open');
					 document.getElementById('burgerMenu').classList.remove('open');
				 })
			 }
		 }

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let sunIco = document.getElementById("sunIco");
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				if(sunIco != null){
					sunIco.classList.add('js-img-two');
				}
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				if(sunIco != null){
					sunIco.classList.add('js-img-two');
				}
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			if(sunIco != null){
				sunIco.classList.remove('js-img-two');
			}
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}